import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useState, useEffect, useRef } from "react";
import { CopilotKit, useCopilotChat } from "@copilotkit/react-core";
import { CopilotSidebar, useChatContext } from "@copilotkit/react-ui";
import ChatInput from "./ChatInput";
import CustomAssistantMessage from "./CustomAssistantMessage";
import CustomUserMessage from "./CustomUserMessage";
import DraggableModal from "./DraggableModal";
import AwesomeIcon from "../AwesomeIcon";
import { faXmark, faRectangleHistoryCirclePlus } from "@fortawesome/pro-regular-svg-icons";
import { useStoreState } from "pullstate";
import Store from "../../utils/Store";
import { trackEvent } from "../../utils/mixpanel";
import { MIXPANEL_EVENTS } from "../../utils/mixpanelEvents";
import { get, isEmpty } from "lodash";
import useConversationLogs from "./utils/actions/useConversationLogs";
import useGetConversationMessages from "./utils/services/useGetConversationMessages";
import useGetConversations from "./utils/services/useGetConversations";
import { useCallback } from "react";
import useWebsocket from "../../hooks/useWebsocket";
import CustomRenderSuggestionsList from "./CustomRenderSuggestionsList";
import useCallGetNextSteps from "./utils/actions/useCallGetNextSteps";
import Image from "next/image";
import useEditConversation from "./utils/services/useEditConversation";
import { useRouter } from "next/router";
import { Role, TextMessage } from "@copilotkit/runtime-client-gql";
import { useAuth } from "@qure/qure-auth";
var CopilotKitSidebar = /*#__PURE__*/React.memo(function (_ref) {
  var userInfo = _ref.userInfo,
    conversationsData = _ref.conversationsData,
    isConversationsSuccess = _ref.isConversationsSuccess,
    refetchConversations = _ref.refetchConversations;
  var _useStoreState = useStoreState(Store, function (s) {
      return {
        assistantThreadId: s.assistantThreadId
      };
    }),
    assistantThreadId = _useStoreState.assistantThreadId;
  var chat = useCopilotChat();
  var _useGetConversationMe = useGetConversationMessages(userInfo === null || userInfo === void 0 ? void 0 : userInfo.default_workspace, assistantThreadId, !!assistantThreadId),
    conversationMessages = _useGetConversationMe.data,
    isConversationMessagesSuccess = _useGetConversationMe.isSuccess;
  var _useConversationLogs = useConversationLogs({
      conversationMessages: conversationMessages,
      conversationsData: conversationsData,
      isConversationsSuccess: isConversationsSuccess,
      isConversationMessagesSuccess: isConversationMessagesSuccess,
      userInfo: userInfo,
      assistantThreadId: assistantThreadId
    }),
    getToolCallMessages = _useConversationLogs.getToolCallMessages,
    setToolCallMessages = _useConversationLogs.setToolCallMessages;
  useEffect(function () {
    if (assistantThreadId && chat !== null && chat !== void 0 && chat.isLoading) {
      chat === null || chat === void 0 || chat.stopGeneration();
      Store.update(function (s) {
        // s.wsEvents = [];
        s.isUsingOrchestrator = false;
      });
    }
  }, [assistantThreadId]);
  useEffect(function () {
    Store.update(function (s) {
      s.setToolCallMessages = setToolCallMessages;
    });
  }, [setToolCallMessages]);
  useEffect(function () {
    Store.update(function (s) {
      s.getToolCallMessages = getToolCallMessages;
    });
  }, [getToolCallMessages]);
  var AssistantMessageComponent = useCallback(function (_ref2) {
    var message = _ref2.message,
      isLoading = _ref2.isLoading,
      subComponent = _ref2.subComponent,
      onThumbsUp = _ref2.onThumbsUp,
      onThumbsDown = _ref2.onThumbsDown,
      onCopy = _ref2.onCopy,
      onRegenerate = _ref2.onRegenerate,
      isCurrentMessage = _ref2.isCurrentMessage,
      rawData = _ref2.rawData;
    return /*#__PURE__*/React.createElement(CustomAssistantMessage, {
      message: message,
      isLoading: isLoading,
      subComponent: subComponent,
      onThumbsUp: onThumbsUp,
      onThumbsDown: onThumbsDown,
      onCopy: onCopy,
      onRegenerate: onRegenerate,
      isCurrentMessage: isCurrentMessage,
      rawData: rawData
    });
  }, []);
  var InputComponent = useCallback(function (_ref3) {
    var onSend = _ref3.onSend,
      inProgress = _ref3.inProgress,
      isVisible = _ref3.isVisible;
    return /*#__PURE__*/React.createElement(ChatInput, {
      inProgress: inProgress,
      isVisible: isVisible,
      onSend: onSend,
      placeholder: "Ask AIRA...",
      conversationsData: conversationsData
    });
  }, []);
  var HeaderComponent = useCallback(function () {
    return null;
  }, []);
  var WindowComponent = useCallback(function (_ref4) {
    var children = _ref4.children;
    return /*#__PURE__*/React.createElement(DraggableModal, {
      conversationsData: conversationsData,
      refetchConversations: refetchConversations
    }, children);
  }, [conversationsData, refetchConversations]);
  return /*#__PURE__*/React.createElement(CopilotSidebar, {
    instructions: "You are assisting the user as best as you can. Answer in the best way possible given the data you have.",
    makeSystemMessage: defaultSystemMessage,
    Header: HeaderComponent,
    Input: InputComponent,
    Window: WindowComponent,
    AssistantMessage: AssistantMessageComponent,
    UserMessage: CustomUserMessage,
    labels: {
      title: "AIRA",
      initial: "**\u2728 Welcome to AIRA \u2728**\n\n\nYour AI clinical assistant for seamless care coordination.\n\n\n**Clinical Tools** \u2013 Manage patient workflows, data/Generate summaries & letters.\n\n\n**Care Management** \u2013 Track patient tags, assignments, status & reminders."
    },
    className: "",
    RenderSuggestionsList: CustomRenderSuggestionsList
  });
});
CopilotKitSidebar.displayName = "CopilotKitSidebar";

// Separate component that handles WebSocket processing without affecting parent
var WebSocketProcessor = /*#__PURE__*/React.memo(function (_ref5) {
  var userInfo = _ref5.userInfo;
  var _useWebsocket = useWebsocket("/llm_orchestrator/".concat(userInfo === null || userInfo === void 0 ? void 0 : userInfo.username, "/patients/"), !isEmpty(userInfo)),
    wsData = _useWebsocket.wsData;
  var _useCopilotChat = useCopilotChat(),
    appendMessage = _useCopilotChat.appendMessage,
    visibleMessages = _useCopilotChat.visibleMessages;
  var getNextSteps = useCallGetNextSteps();
  var allowNextSteps = process.env.NEXT_PUBLIC_ALLOW_NEXT_STEPS === "true";
  useEffect(function () {
    if (wsData && wsData.action === "chatbot") {
      if (wsData.status === "started") {
        var patientUid = wsData === null || wsData === void 0 ? void 0 : wsData.patient_uid;
        Store.update(function (s) {
          if (s.currentPatientsUsingOrchestrator[patientUid] && s.currentPatientsUsingOrchestrator[patientUid].status !== "request_failed") {
            s.currentPatientsUsingOrchestrator[patientUid] = _objectSpread(_objectSpread({}, s.currentPatientsUsingOrchestrator[patientUid]), {}, {
              status: "started"
            });
          }
          // Initialize wsEvents array if it doesn't exist yet
          if (!s.wsEvents[patientUid]) {
            s.wsEvents[patientUid] = [];
          }
        });
      } else if (wsData.status === "in_progress") {
        var _patientUid = wsData === null || wsData === void 0 ? void 0 : wsData.patient_uid;
        Store.update(function (s) {
          if (s.currentPatientsUsingOrchestrator[_patientUid] && s.currentPatientsUsingOrchestrator[_patientUid].status !== "started") {
            s.currentPatientsUsingOrchestrator[_patientUid] = _objectSpread(_objectSpread({}, s.currentPatientsUsingOrchestrator[_patientUid]), {}, {
              status: "in_progress"
            });
          }
          if (!s.wsEvents[_patientUid]) {
            s.wsEvents[_patientUid] = [];
          }
          s.wsEvents[_patientUid].push(wsData.content);
        });
      } else if (wsData && (wsData.status === "completed" || wsData.status === "failed")) {
        var _Store$getRawState$ws, _wsData$content, _Store$getRawState$cu;
        var lastUserMessage = visibleMessages.findLast(function (message) {
          return message.role === "user";
        });
        var patientWsEvents = (_Store$getRawState$ws = Store.getRawState().wsEvents[wsData === null || wsData === void 0 ? void 0 : wsData.patient_uid]) === null || _Store$getRawState$ws === void 0 ? void 0 : _Store$getRawState$ws.map(function (event) {
          return event === null || event === void 0 ? void 0 : event.response;
        });
        var content = "";
        if (typeof (wsData === null || wsData === void 0 || (_wsData$content = wsData.content) === null || _wsData$content === void 0 ? void 0 : _wsData$content.content) !== "undefined") {
          content = wsData.content.content;
        } else if (typeof (wsData === null || wsData === void 0 ? void 0 : wsData.content) !== "undefined") {
          content = wsData.content;
        }
        Store.update(function (s) {
          s.saveFallbackToolCall = false;
          s.isUsingOrchestrator = false;
          s.lastSavedUserMessageId = "";
          s.currentPatientsUsingOrchestrator[wsData === null || wsData === void 0 ? void 0 : wsData.patient_uid] = _objectSpread(_objectSpread({}, s.currentPatientsUsingOrchestrator[wsData === null || wsData === void 0 ? void 0 : wsData.patient_uid]), {}, {
            status: "completed"
          });
          delete s.wsEvents[wsData === null || wsData === void 0 ? void 0 : wsData.patient_uid];
        });
        if (((_Store$getRawState$cu = Store.getRawState().currentPatientsUsingOrchestrator[wsData === null || wsData === void 0 ? void 0 : wsData.patient_uid]) === null || _Store$getRawState$cu === void 0 ? void 0 : _Store$getRawState$cu.conversation_id) === Store.getRawState().assistantThreadId) {
          appendMessage(new TextMessage({
            role: Role.Assistant,
            content: content,
            id: "doNotSave_".concat(lastUserMessage === null || lastUserMessage === void 0 ? void 0 : lastUserMessage.id),
            parentMessageId: lastUserMessage === null || lastUserMessage === void 0 ? void 0 : lastUserMessage.id
          }), {
            followUp: false
          });
          if (allowNextSteps) {
            getNextSteps.callGetNextSteps();
          }
          var setToolCallMessages = Store.getRawState().setToolCallMessages;
          setToolCallMessages(lastUserMessage, patientWsEvents || []);
        }
      }
    }
  }, [wsData]);
  return null; // This component doesn't render anything
});
WebSocketProcessor.displayName = "WebSocketProcessor";

// Separate component that handles patient conversation logic without affecting parent
var PatientConversationProcessor = /*#__PURE__*/React.memo(function (_ref6) {
  var userInfo = _ref6.userInfo;
  var _useStoreState2 = useStoreState(Store, function (s) {
      return {
        patientDetail: s.patientDetail
      };
    }),
    patientDetail = _useStoreState2.patientDetail;
  var hasCreatedConversation = useRef(null);
  var _useGetConversations = useGetConversations(userInfo === null || userInfo === void 0 ? void 0 : userInfo.default_workspace, patientDetail === null || patientDetail === void 0 ? void 0 : patientDetail.patient_id, !!(patientDetail !== null && patientDetail !== void 0 && patientDetail.patient_id)),
    conversationsData = _useGetConversations.data,
    isConversationsSuccess = _useGetConversations.isSuccess,
    refetchPatientConversations = _useGetConversations.refetch,
    isConversationMessagesError = _useGetConversations.isError,
    isConversationsLoading = _useGetConversations.isLoading;
  useEffect(function () {
    Store.update(function (s) {
      s.refetchPatientConversations = refetchPatientConversations;
      s.patientConversations = (conversationsData === null || conversationsData === void 0 ? void 0 : conversationsData.results) || s.patientConversations;
    });
  }, [refetchPatientConversations]);
  var editConversation = useEditConversation(userInfo === null || userInfo === void 0 ? void 0 : userInfo.default_workspace);
  useEffect(function () {
    if (isConversationMessagesError) {
      Store.update(function (s) {
        s.assistantThreadId = s.lastConversationId;
        s.assistantMode = "simple";
        s.areFrontendToolsEnabled = true;
        s.customSuggestions = [];
      });
    }
  }, [isConversationMessagesError]);
  useEffect(function () {
    if (isConversationsLoading || !(patientDetail !== null && patientDetail !== void 0 && patientDetail.patient_id) || !isConversationsSuccess || !conversationsData) {
      return;
    }
    var currentPatientId = patientDetail.patient_id;
    if (conversationsData.results.length > 0) {
      var conversation = conversationsData.results[0];
      if (conversation) {
        Store.update(function (s) {
          s.accessPastChat = true;
          s.patientConversations = conversationsData.results || [];
          s.areFrontendToolsEnabled = false;
        });
        if (!Store.getRawState().selectedFilterPatientTool) {
          Store.update(function (s) {
            s.assistantThreadId = conversation.conversation_id;
            s.assistantMode = "workflow";
          });
        }
      }
      hasCreatedConversation.current = currentPatientId;
    } else if (conversationsData.results.length === 0) {
      if (hasCreatedConversation.current === currentPatientId) {
        return;
      }
      if (editConversation.isLoading) {
        return;
      }
      hasCreatedConversation.current = currentPatientId;
      var payload = {
        title: "Patient ".concat(currentPatientId, " - ").concat(new Date().toISOString()),
        patient_id: currentPatientId
      };
      editConversation.mutateAsync(payload).then(function (resp) {
        Store.update(function (s) {
          s.assistantThreadId = resp.conversation_id;
          s.patientConversations = [resp];
          // s.wsEvents = [];
          s.assistantMode = "workflow";
          s.areFrontendToolsEnabled = false;
          s.customSuggestions = [];
        });
      })["catch"](function (error) {
        console.error("Failed to create conversation:", error);
        hasCreatedConversation.current = null;
      });
    }
    if (Store.getRawState().selectedFilterPatientTool) {
      Store.update(function (s) {
        s.selectedFilterPatientTool = false;
      });
    }
  }, [conversationsData, isConversationsSuccess, isConversationsLoading, patientDetail === null || patientDetail === void 0 ? void 0 : patientDetail.patient_id, editConversation.isLoading]);
  return null;
});
PatientConversationProcessor.displayName = "PatientConversationProcessor";
var CopilotWrapper = /*#__PURE__*/React.memo(function (_ref7) {
  var children = _ref7.children;
  var _Store$getRawState = Store.getRawState(),
    patient = _Store$getRawState.patient;
  var _useAuth = useAuth(),
    userInfo = _useAuth.userInfo;
  var isEnabled = get(userInfo, ["settings", "ui_settings", "ai_assistant"], true);
  var hasCalledNextSteps = useRef(false);
  var router = useRouter();
  if (router.pathname === "/worklist-v2" || router.pathname === "/worklist") {
    Store.update(function (s) {
      s.assistantMode = "simple";
      s.areFrontendToolsEnabled = true;
      s.patientDetail = {}, s.customSuggestions = [];
    });
  }
  var _useCallGetNextSteps = useCallGetNextSteps(),
    callGetNextSteps = _useCallGetNextSteps.callGetNextSteps;
  useEffect(function () {
    var patientId = patient === null || patient === void 0 ? void 0 : patient.patient_id;
    if (!hasCalledNextSteps.current && userInfo !== null && userInfo !== void 0 && userInfo.default_workspace && patientId) {
      hasCalledNextSteps.current = true;
      callGetNextSteps(patientId);
    }
  }, [userInfo === null || userInfo === void 0 ? void 0 : userInfo.default_workspace, patient === null || patient === void 0 ? void 0 : patient.patient_id, callGetNextSteps]);
  var _useGetConversations2 = useGetConversations(userInfo === null || userInfo === void 0 ? void 0 : userInfo.default_workspace),
    conversationsData = _useGetConversations2.data,
    isConversationsSuccess = _useGetConversations2.isSuccess,
    refetchConversations = _useGetConversations2.refetch;
  useEffect(function () {
    Store.update(function (s) {
      var _conversationsData$re;
      s.lastConversationId = conversationsData === null || conversationsData === void 0 || (_conversationsData$re = conversationsData.results[0]) === null || _conversationsData$re === void 0 ? void 0 : _conversationsData$re.conversation_id;
    });
  }, [conversationsData]);
  var _Store$getRawState2 = Store.getRawState(),
    assistantMode = _Store$getRawState2.assistantMode;
  return /*#__PURE__*/React.createElement(CopilotKit, {
    runtimeUrl: "/api/copilotkit",
    headers: {
      "x-ai-assistant-enabled": userInfo ? String(isEnabled) : ""
    },
    showDevConsole: false
  }, children, /*#__PURE__*/React.createElement(WebSocketProcessor, {
    userInfo: userInfo
  }), /*#__PURE__*/React.createElement(PatientConversationProcessor, {
    userInfo: userInfo
  }), /*#__PURE__*/React.createElement(CopilotKitSidebar, {
    userInfo: userInfo || null,
    conversationsData: conversationsData,
    isConversationsSuccess: isConversationsSuccess,
    refetchConversations: refetchConversations
  }));
});
CopilotWrapper.displayName = "CopilotWrapper";
function defaultSystemMessage(contextString, additionalInstructions) {
  var _Store$getRawState3 = Store.getRawState(),
    assistantMode = _Store$getRawState3.assistantMode;
  var baseMessage = "\nYou are the AI Assistant built by Qure to support healthcare workers \u2014 including doctors, nurses, and other clinical staff \u2014 in managing patient workflows efficiently and safely.\n\nPlease respond only in English. If the user inputs a message in any other language, politely inform them that you can only continue the conversation in English. Do not attempt to translate or reply in another language.\n".concat(contextString ? "Context: ".concat(contextString) : "", "\n");
  switch (assistantMode) {
    case "auto":
      return baseMessage + "\nMODE: AUTO MODE\nYour goal is to intelligently decide which tools to use based on the user's query.\n\nInstructions:\n- If the user query clearly matches a tool, invoke that tool directly\n- If the user's query does not match any available tool, call useFallbackHandler\n- If you are unsure how to handle the query or need additional information, call useFallbackHandler\n- Do not inform the user that you lack access to certain information or cannot perform an action\n- Instead, silently route such cases to useFallbackHandler\n- Use your best judgment to select the most appropriate tool for the user's request\n\n".concat(additionalInstructions ? additionalInstructions : "", "\n");
    case "simple":
      return baseMessage + "\n".concat(additionalInstructions ? additionalInstructions : "", "\n");
    case "workflow":
      return baseMessage + "\nMODE: WORKFLOW MODE\nYou are operating in Workflow Mode, where precise handling is critical.\n\nInstructions:\n- Whatever happens, you must call useFallbackHandler\n- Whatever user asks, simply call useFallbackHandler. No questions, no doubts, no hesitation\n- Do not ask user to select what patient they want to work on - it is already selected\n- All ambiguity or unhandled cases must be delegated without hesitation\n- If any tool fails to clearly match, or you are missing information, or you are uncertain, you must immediately call useFallbackHandler\n- Never guess, assume, or speculate\n- Do not attempt partial answers or improvise\n- Do not inform the user about internal limitations\n- Always redirect by calling useFallbackHandler when in doubt or when tools are insufficient\n\n";
    default:
      return baseMessage + (additionalInstructions ? additionalInstructions : "");
  }
}
var Header = function Header() {
  var sortMessagesInPlace = function sortMessagesInPlace(messages) {
    messages.sort(function (a, b) {
      return new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime();
    });
    var seen = new Set();
    var result = [];
    var _iterator = _createForOfIteratorHelper(messages),
      _step;
    try {
      var _loop = function _loop() {
        var message = _step.value;
        if (seen.has(message.id)) return 1; // continue
        if (message.type === "ActionExecutionMessage") {
          result.push(message);
          seen.add(message.id);
          var resultMessage = messages.find(function (m) {
            return m.type === "ResultMessage" && m.actionExecutionId === message.id;
          });
          if (resultMessage && !seen.has(resultMessage.id)) {
            result.push(resultMessage);
            seen.add(resultMessage.id);
          }
        } else {
          result.push(message);
          seen.add(message.id);
        }
      };
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        if (_loop()) continue;
      }

      // Overwrite original array with result (in-place modification)
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    messages.length = 0;
    messages.push.apply(messages, result);
  };
  var onPastChatClick = function onPastChatClick() {
    Store.update(function (s) {
      s.isPastChatOpen = true;
    });
  };
  var _useChatContext = useChatContext(),
    labels = _useChatContext.labels;
  var chat = useCopilotChat();
  var messages = chat.visibleMessages || [];
  // sortMessagesInPlace(messages);
  var setMessages = chat.setMessages;
  var _useState = useState(false),
    isMobile = _useState[0],
    setIsMobile = _useState[1];
  React.useEffect(function () {
    if (typeof window !== "undefined") {
      setIsMobile(window.matchMedia("(max-width: 639px)").matches);
    }
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: "w-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full drag-handle cursor-move flex items-center justify-between bg-gray-700 h-8 px-6 border-b dark:bg-gray-800 border-teal-800 text-white shadow-[0_4px_24px_rgba(20,50,100,0.85)]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center relative"
  }, /*#__PURE__*/React.createElement(Image, {
    src: "/assets/icons/aira-logo.svg",
    alt: "aira-logo",
    width: "24",
    height: "24"
  }), /*#__PURE__*/React.createElement("span", {
    className: "ml-3 text-lg font-bold font-sans"
  }, labels.title)), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-end items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex space-x-3 items-center"
  }, /*#__PURE__*/React.createElement("button", {
    className: "pr-2",
    onClick: onPastChatClick
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faRectangleHistoryCirclePlus,
    size: "lg",
    className: ""
  })), /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      Store.update(function (s) {
        s.isDraggableModalOpen = !s.isDraggableModalOpen;
      });
      trackEvent(MIXPANEL_EVENTS.ASSISTANT_MODAL_BUTTONS, {
        button_type: "close",
        action: "click"
      });
    },
    "aria-label": "Close",
    title: "Close",
    className: "text-white hover:text-teal-400  p-1 px-2 rounded-full transition-all duration-200 hover:scale-120"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faXmark,
    size: "lg"
  }))))));
};
export default CopilotWrapper;